module.exports = __webpack_public_path__ + "108ee46062409d87a09e9e3e053adf36.svg";